import { useMediaQuery } from '@mui/material';

export default function useResponsive() {
	let small = useMediaQuery('(max-width:700px)');
	let medium = useMediaQuery('(max-width:1300px)');
	let large;
	return { small, medium, large };
}
